<template>
  <div class="card mb-25 border-0 rounded-0 mb-20">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <h4 class="card-title fw-black mb-0">{{ virement.ref }}</h4>
          <br />
          <p>
            Date de création :
            <b v-if="virement.created_at">
              {{ getDate(virement.created_at) }}</b
            >
            |
            <b>{{ virement?.c_by_name }} </b>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Factures enregistrées</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div class="col-md-3 d-flex justify-content-start mb-1 mb-md-0">
            <button
              v-if="virement.statut === 0 && auth.can('ADD_VIREMENT')"
              style="margin-right: 12px"
              class="btn btn-success"
              @click="AddNewColis"
            >
              Ajouter</button
            ><br />
            <v-select
              v-model="users.per_page"
              :options="[10, 50]"
              :clearable="false"
              @input="getRecords1()"
            />
            <!-- <label>{{ users.total }} entités</label> -->
            <!-- <template v-if="virement.note_saved!=1">
            <button style="border-color: #7367f0 !important;background-color: #7367f0 !important;color: #fff !important;"
                    variant="bluecol"
                    @click="SaveReception"
                >
                    Enregister
            </button>
            </template> -->
          </div>
          <div class="col-md-9">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group">
                <div class="d-flex align-items-center">
                  <input
                    v-model="users.searchTerm"
                    placeholder="Chercher"
                    type="text"
                    class="form-control"
                    @input="getRecords1()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'facture Sélectionées',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'invoice_ref'">
            <b>{{ props.row.invoice_ref }}</b>
          </template>

          <template v-else-if="props.column.field === 'total_to_send'">
            <b>{{ props.row.total_to_send }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'parcels_num'">
            <b>{{ props.row.parcels_num }}</b> Colis
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            <span v-if="props.row.created_at" class="text-nowrap">
              {{ getDate(props.row.created_at) }}<br />
              {{ props.row.create_by_name }}
            </span>
            <span v-else class="text-nowrap" />
          </template>

          <template v-else-if="props.column.field === 'customer_name'">
            <b>{{ props.row.client?.store ?? '' }}</b><br />
            <p class="text-nowrap">
              {{ props.row.client?.bank ?? '' }}<br />
              <span style="color: #ff9f43">{{ props.row.client?.rib ?? '' }}</span>
            </p>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-md-6" />
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users"
            :offset="9"
            @paginate="getRecords1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Factures ajoutées</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div class="col-md-3 d-flex justify-content-start mb-1 mb-md-0">
            <button
              v-if="virement.statut === 0 && auth.can('ADD_VIREMENT')"
              style="margin-right: 12px"
              class="btn btn-danger"
              @click="RemoveNewColis"
            >
              Supprimer</button
            ><br />
            <v-select
              v-model="users2.per_page"
              :options="[10, 50]"
              :clearable="false"
              @input="getRecords2()"
            />
            <!-- <label>{{ users2.total }} entités</label> -->
            <!--   <template v-if="Reception.note_saved!=1">
                <button style="border-color: #7367f0 !important;background-color: #7367f0 !important;color: #fff !important;"
                      variant="bluecol"
                      @click="SaveReception"
                    >
                      Enregister
                </button>
              </template>-->
          </div>
          <div cols="12" md="9">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group">
                <div class="d-flex align-items-center">
                  <input
                    v-model="users2.searchTerm"
                    placeholder="Chercher"
                    type="text"
                    class="form-control"
                    @input="getRecords2()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'invoice_ref'">
            <b>{{ props.row.invoice_ref }}</b>
          </template>

          <template v-else-if="props.column.field === 'total_to_send'">
            <b>{{ props.row.total_to_send }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'parcels_num'">
            <b>{{ props.row.parcels_num }}</b> Colis
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            <span v-if="props.row.created_at" class="text-nowrap">
              {{ getDate(props.row.created_at) }}<br />
              {{ props.row.create_by_name }}
            </span>
            <span v-else class="text-nowrap" />
          </template>

          <template v-else-if="props.column.field === 'customer_name'">
            <b>{{ props.row.client?.store ?? '' }}</b><br />
            <p class="text-nowrap">
              {{ props.row.client?.bank ?? '' }}<br />
              <span style="color: #ff9f43">{{ props.row.client?.rib ?? '' }}</span>
            </p>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-md-6" />
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users2"
            :offset="9"
            @paginate="getRecords2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useRouter, useRoute } from "vue-router";
import api from "@/utils/axios";
import { useGlobalStore } from "@/stores/global";
import moment from "moment";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const router = useRouter();
    const route = useRoute();
    const globalStore = useGlobalStore();

    const isLoader = ref(true);
    const columns = [
      {
        label: "Réf",
        field: "invoice_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Colis",
        field: "parcels_num",
      },
      {
        label: "Montant",
        field: "total_to_send",
      },
    ];

    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);

    const codeColis = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const virement = ref<any>({});
    const loading1 = ref(false);
    const loading2 = ref(false);
    const users = ref({
      searchTerm: "",
      searchCustomer: "",
      searchTotal: "",
      searchBank: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = ref({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const CustomerList = ref([]);
    const BankList = ref([]);
    const client_filter = ref({ id: "", name: "" });
    // const bank_filter = ref({ id: '', name: '' });
    const bank_filter = ref([]);
    const total_filter = ref("");
    const searchTimeout = ref(null);

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    const onSearchClients = (search: string, loading: (b: boolean) => void) => {
      clearTimeout(searchTimeout.value);
      searchTimeout.value = setTimeout(() => {
        filterClients(search, loading);
      }, 300);
    };

    const filterClients = (search: string, loading: (b: boolean) => void) => {
      loading(true);
      const query = search.toLowerCase();
      if (query) {
        api
          .get(`/api/auth/ListCustsFilter?query=${query}`)
          .then((res) => {
            CustomerList.value = res.data;
            loading(false);
          })
          .catch((error) => {
            console.error(error);
            loading(false);
          });
      } else {
        loading(false);
      }
    };

    const SearchColis = () => {
      const data = new FormData();
      data.append("cstmr_id", String(route.params.id));
      data.append("code_colis", codeColis.value);
      isLoader.value = true;
      api
        .post("/api/auth/SearchColisNote", data)
        .then((res) => {
          isLoader.value = false;
          if (res.data.message == "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
          } else if (res.data.message == "not exist") {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Vous ne pouvez pas l'ajouter", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Pleaz try again", "error");
        });
    };

    const onSelectAll = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };

    const selectionChanged = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };

    const onSelectAllColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };

    const selectionChangedColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };

    const getData = () => {
      isLoader.value = true;
      api
        .get("/api/auth/show_transfer", {
          params: { ref: route.params.refNote },
        })
        .then((res) => {
          virement.value = res.data.VIR;
        })
        .finally(() => {
          isLoader.value = false;
        });
    };

    function getRecords1(page = 1) {
      loading1.value = true;
      users.value.current_page = page;
      api
        .get(
          `/api/auth/list_saved_invoices?searchTerm=${users.value.searchTerm}&searchBank=${users.value.searchBank}&searchTotal=${users.value.searchTotal}&searchCustomer=${users.value.searchCustomer}&page=${users.value.current_page}&per_page=${users.value.per_page}`
        )
        .then((res) => {
          rows1.value = res.data.users.data;
          users.value = res.data.users;
        })
        .finally(() => {
          loading1.value = false;
        });
    }

    function getRecords2(page = 1) {
      loading2.value = true;
      users2.value.current_page = page;
      api
        .get(
          `/api/auth/list_invoices_in?searchTerm=${users2.value.searchTerm}&page=${users2.value.current_page}&per_page=${users2.value.per_page}`,
          { params: { ref: route.params.refNote } }
        )
        .then((res) => {
          rows2.value = res.data.users.data;
          users2.value = res.data.users;
        })
        .finally(() => {
          loading2.value = false;
        });
    }

    const AddNewColis = () => {
      if (SelectedRows.value.length == 0) {
        showToast("Vous pouvez pas supprimer à ce virement", "error");
      } else {
        const data = new FormData();
        data.append("invoices", JSON.stringify(SelectedRows.value));
        data.append("ref", String(route.params.refNote));
        api.post("/api/auth/Add_inv_to_trnsf", data).then((res) => {
          if (res.data.message == "success") {
            const audio = new Audio("/sound.mp3");
          audio.play();
            showToast("ajouté avec succès", "success");
            // audio.play();
            getData();
            getRecords1();
            getRecords2();
          } else {
            showToast("Something went wrong! Pleaz try again", "error");
          }
        });
      }
    };

    const RemoveNewColis = () => {
      if (SelectedNewRows.value.length == 0) {
        showToast("Vous pouvez pas supprimer à ce virement", "error");
      } else {
        const data = new FormData();
        data.append(
          "UserID",
          String(JSON.parse(localStorage.getItem("userData") || "{}").id)
        );
        data.append("invoices", JSON.stringify(SelectedNewRows.value));
        data.append("ref", String(route.params.refNote));
        api.post("/api/auth/remove_inv_trnsf", data).then((res) => {
          if (res.data.message == "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            showToast("supprimé avec succès", "success");
            getData();
            getRecords1();
            getRecords2();
          } else {
            showToast("Something went wrong! Pleaz try again", "error");
          }
        });
      }
    };

    const Removefilter = () => {
      users.value.searchCustomer = "";
      users.value.searchBank = "";
      users.value.searchTerm = "";
      users.value.searchTotal = "";
      client_filter.value = { id: "", name: "" };
      bank_filter.value = [];
      total_filter.value = "";
      users.value.current_page = 1;
      getRecords1();
    };

    const filter = () => {
      users.value.searchCustomer = client_filter.value.id;
      if (bank_filter.value && bank_filter.value.length != 0) {
        users.value.searchBank = bank_filter.value
          .map((bank: any) => bank.name)
          .join(",");
      }
      users.value.searchTotal = total_filter.value;
      getRecords1();
    };

    onMounted(() => {
      getData();
      getRecords1();
      getRecords2();
    });
    return {
      isLoader,
      columns,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      rows1,
      rows2,
      virement,
      loading1,
      loading2,
      users,
      users2,
      CustomerList,
      BankList,
      client_filter,
      bank_filter,
      total_filter,
      searchTimeout,
      showToast,
      getDate,
      auth,
      user,
      router,
      route,
      globalStore,
      onSearchClients,
      filterClients,
      getRecords2,
      getRecords1,
      AddNewColis,
      RemoveNewColis,
      Removefilter,
      filter,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
    };
  },
});
</script>
  